var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"el-fade-in"}},[_c('div',{staticClass:"network-error"},[_c('div',{staticClass:"network-error-content"},[_c('span',{staticClass:"icon"}),_c('div',{staticClass:"txt"},[_c('span',[_vm._v(_vm._s(_vm.errorTip))]),(_vm.showBtn)?_c('button',{on:{"click":_vm.btnClickFn}},[_vm._v(_vm._s(_vm.btnText))]):_vm._e()])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }